// src/components/Footer/Footer.js
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  DashboardOutlined,
  Dashboard,
  LocalShippingOutlined,
  LocalShipping,
  AttachMoneyOutlined,
  AttachMoney,
  PersonOutline,
  Person,
} from "@mui/icons-material";
import "./footer.css";

const Footer = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();

  // Hide footer on login/signup/forgot pages
  const hideFooterPaths = ["/", "/signup", "/forgot"];
  const shouldHideFooter = hideFooterPaths.includes(location.pathname);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  
  if (windowWidth >= 992 || shouldHideFooter) return null;

  const menuItems = [
    { label: "Dashboard", path: "/dashboard", icon: DashboardOutlined, activeIcon: Dashboard },
    { label: "My Delivery", path: "/history", icon: LocalShippingOutlined, activeIcon: LocalShipping },
    { label: "My Earnings", path: "/earnings", icon: AttachMoneyOutlined, activeIcon: AttachMoney },
    { label: "Profile", path: "/profile", icon: PersonOutline, activeIcon: Person },
  ];

  return (
    <div className="footer-nav">
      {menuItems.map((item) => {
        const isActive = location.pathname === item.path;
        const Icon = isActive ? item.activeIcon : item.icon;

        return (
          <Link
            key={item.path}
            to={item.path}
            className={`footer-item ${isActive ? "active" : ""}`}
          >
            <Icon className="footer-icon" />
            <span className="footer-title">{item.label}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default Footer;
